export enum PrizeRedemptionDialogViews {
	Form = 'form',
	Confirmation = 'confirmation',
	ZeroPoints = 'zeroPoints',
}
